import React, { useContext } from "react";
import AuthLabeledTextInput from "../../components/Inputs/AuthLabeledTextInput";
import { useState } from "react";
import SquareButton from "../../components/Buttons/SquareButton";
import ChoosePlanInput, { buildPlanFromForm } from "./ChoosePlanInput";
import { useNavigate } from "react-router-dom";
import PersonalInfoFields from "./PersonalInfoFields";
import { useQuery } from "@tanstack/react-query";
import { AuthContext } from "../../AuthContext";
const BasicInfoForm = ({ selectedPlan, handleSubmit, currentUser }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [mySelectedPlan, setMySelectedPlan] = useState(selectedPlan);
  const navigate = useNavigate();
  const { tokenAvailable, authReady } = useContext(AuthContext);

  // If we have a current user and a firebase user - we should check if they already have a company:
  const shouldQueryCompanies = currentUser?.uid != null && tokenAvailable;
  const companyQuery = useQuery({
    queryKey: [`user/${currentUser?.uid}/companies`],
    enabled: shouldQueryCompanies,
  });
  const { data: pricingData } = useQuery({ queryKey: ["stripe/pricing"] });
  const plans = pricingData?.plans ?? [];

  // Don't display our form until we have the data we need to load it:
  if (!authReady) return null;
  if (companyQuery.isLoading) {
    return null;
  }
  const existingOwnedCompanyId = shouldQueryCompanies
    ? companyQuery.data?.userCompanies?.find(
        (c) => c.ownerUid === currentUser.uid,
      )?._id
    : null;

  const onFormSubmit = async (e) => {
    setIsLoading(true);
    try {
      const form = e.nativeEvent.target;
      const selectedPlanOptions = buildPlanFromForm(e.nativeEvent, plans);
      const data = {
        phone: form.phone?.value,
        firstName: form.first_name?.value,
        lastName: form.last_name?.value,
        companyName: form.company_name?.value,
        ...selectedPlanOptions,
        email: form.email?.value,
        existingCompanyId: form.existing_company_id?.value,
        agreeToTerms: form.terms.checked,
      };
      if (typeof handleSubmit === "function") {
        await handleSubmit(data);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onFormSubmit(e);
      }}
      className="sign-up-form p-2"
    >
      <h1 className="text-2xl lg:text-3xl font-bold">Sign Up</h1>
      {existingOwnedCompanyId ? (
        <input
          type="hidden"
          value={existingOwnedCompanyId}
          name="existing_company_id"
        />
      ) : (
        <AuthLabeledTextInput
          disabled={false}
          placeholder="Company Name"
          name="company_name"
          label="Company Name"
          required
          autoFocus
        />
      )}
      <PersonalInfoFields currentUser={currentUser} />
      {selectedPlan ? (
        <input type="hidden" name="plan" value={selectedPlan} />
      ) : (
        <ChoosePlanInput
          defaultShowCustomizePlan={false}
          name="plan"
          onPlanChange={(plan) => setMySelectedPlan(plan)}
          excludePlans={["park-mode-2026"]}
        />
      )}
      <label className="my-2 block text-sm">
        <input
          type="checkbox"
          name="terms"
          required
          data-testid="agree-terms"
        />{" "}
        Agree to{" "}
        <a href="/terms" className="underline">
          Terms & Conditions
        </a>
      </label>
      <p className="my-2 text-sm">
        If you want to join an existing company{" "}
        <a
          onClick={(e) => {
            e.preventDefault();
            let phone = document.querySelector("[name='phone']")?.value;
            navigate("/admin-login?phone=" + encodeURIComponent(phone));
          }}
          className="underline cursor-pointer"
          href="/admin-login"
        >
          just login.
        </a>{" "}
      </p>

      <SquareButton
        label={
          mySelectedPlan?.toLocaleLowerCase()?.includes("hansolo") === true
            ? "Sign Up Now"
            : "Checkout Now"
        }
        color="blue"
        loading={isLoading}
        disabled={isLoading}
        className="max-w-none"
        testId="basic-info-submit"
        type="submit"
      />
    </form>
  );
};

export default BasicInfoForm;
